import { render, staticRenderFns } from "./LockerCompanyLogs.vue?vue&type=template&id=4236bc67&"
import script from "./LockerCompanyLogs.vue?vue&type=script&lang=ts&"
export * from "./LockerCompanyLogs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports